import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { Observable } from 'rxjs';
import { ApiVisa, ApiResponseModel } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class NoPricingSchemeOrganisationService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'no-pricing-schemes/organisation/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'no-pricing-schemes/organisation/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'no-pricing-schemes/organisation/backoffice-ep';
    this.httpClient = http;
  }

  public getByPostCriteria(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}